import { createContext } from "react";

export const VesselOptions = createContext();
